import { ServiceMaker, methods, services } from "@/services";

export const invoiceHistory = () =>
  ServiceMaker(
    "/subscription-payments/subscription/my-invoice",
    methods.GET,
    services.master
  );

export const partnerInvoiceHistory = payload =>
  ServiceMaker(
    `subscription-payments/subscription/invoice/${payload.id}`,
    methods.POST,
    services.master,
    payload.data
  );

export const partnerInvoiceBill = payload =>
  ServiceMaker(
    `subscription-payments/subscription/my-invoice/${payload}`,
    methods.GET,
    services.master
  );

export const partnerMyUnbilledInvoiceBill = payload =>
  ServiceMaker(
    `/subscription-payments/subscription/my-unbilled-items`,
    methods.GET,
    services.master
  );

export const partnerUnbilledInvoiceBillByTenant = id =>
  ServiceMaker(
    `/subscription-payments/subscription/billing-items/${id}`,
    methods.POST,
    services.master,
    {
      status: "UNBILLED"
    }
  );
